import LazyLoad from '../../services/lazyLoad';

const LazyComponent = LazyLoad({ loader: () => import('./Calendar') });

export default function Calendar() {
  return <LazyComponent />;
}
